import { useLoginVerify } from './useLoginVerify';
export function useIsUngated(gate) {
  var _loginVerifyData$feat, _loginVerifyData$feat2;
  const {
    data: loginVerifyData
  } = useLoginVerify();
  return (_loginVerifyData$feat = loginVerifyData === null || loginVerifyData === void 0 || (_loginVerifyData$feat2 = loginVerifyData.featuresEnabled) === null || _loginVerifyData$feat2 === void 0 ? void 0 : _loginVerifyData$feat2.includes(gate)) !== null && _loginVerifyData$feat !== void 0 ? _loginVerifyData$feat : false;
}